function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M6 5.19l3.969-3.973a.747.747 0 011.06 0c.29.294.29.77 0 1.063L6.53 6.78a.749.749 0 01-1.034.022L.969 2.283a.75.75 0 01-.219-.531.75.75 0 011.278-.531L6 5.189z",
  fill: "#4F4F4F"
});

function SvgCollapse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 7",
    fill: "none"
  }, props), _ref);
}

export default SvgCollapse;